import axios from 'axios';
import {filterGetters, filterStore} from "./filterStore";
const apiUrl = '/admin/api/';

export default {

    // Api getInfo now only gives us our first date where a Notification event or Notification Event Log is found
    async getInfo()
    {
        let response = await axios.get(apiUrl + 'info');
        return response.data;
    },

    async getCareGroups()
    {
        let response = await axios.get(apiUrl + 'caregroups');
        return response.data;
    },

    async getResponsesToNotifications(values)
    {
        let queryString = this.buildQueryString(values);

        let response = await axios.get(apiUrl + 'notifications/responses' + queryString);
        // debugger
        return response.data;
    },

    async getResponsesToNotificationsCount()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'notifications/responses/count' + queryString);
        return response.data;
    },

    async getNotificationTypeCount()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'notifications/typecount' + queryString);
        return response.data;
    },

    async getNotificationsAcceptedDurationSpikes()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'notifications/accepteddurationspikes' + queryString);
        return response.data;
    },

    async getEmployeesWithScore()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'employeeswithscore' + queryString);
        return response.data;
    },

    async getEmployeesOnline()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'employeesonline' + queryString);
        return response.data;
    },

    async getRoomNames()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'roomnames' + queryString);
        return response.data;
    },

    async getUsers()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'users' + queryString);

        return Object.values(response.data);
    },

    async getNotificationMeanResponseTime()
    {
        let queryString = this.buildQueryString();

        let response = await axios.get(apiUrl + 'notifications/meanreactiontime' + queryString);
        return response.data;
    },

    buildQueryString(values = null)
    {
        let params = values ? Object.assign(values) : {};

        // Get the start- and endDate from the filters
        params = Object.assign(params, this.parseStartAndEndDate());

        // Get the roomNames from the filters
        let roomNames = {
            rooms: filterStore.selectedRoomNames
        };

        params = Object.assign(params, roomNames);

        // Get the users from the filters
        let users = {
            users: filterGetters.getSelectedUserIdsAsString()
        };

        params = Object.assign(params, users);

        let queryParamsString = new URLSearchParams(params).toString();
        return '?' + queryParamsString;
    },

    // Be aware that this behaviour has changed, and now should be named pasrseStartAndEndDateTime (added 'time')
    parseStartAndEndDate()
    {
        // Get start- and endDate from the store
        let startDate = filterStore.dateRange.startDate;
        let endDate = filterStore.dateRange.endDate;

        // Test values to test (probably) all entries
        // startDate = moment({ year: 1998, month: 1, day: 1});
        // endDate = moment({ year: 2030, month: 2, day: 1});

        return {
            startDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(endDate).format('YYYY-MM-DD HH:mm:ss')
        };
    }

}
